import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import type { Nav4DragAndDropMenuItemProps } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { CustomerServiceMenuLinkItem } from './ui/index.tsx';

interface Props extends Nav4DragAndDropMenuItemProps {}

export const CustomerService = (props: Props): React.JSX.Element => (
	<UFOSegment name="nav4-sidebar-customer-service">
		<JSErrorBoundary
			fallback="flag"
			id="assets"
			packageName="jiraNavigationAppsSidebarNav4SidebarsContentCustomerService"
			teamName="Boysenberry"
		>
			<CustomerServiceMenuLinkItem {...props} />
		</JSErrorBoundary>
	</UFOSegment>
);
